import { DataGrid, getGridStringOperators} from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiDataGrid-toolbar': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderBottom: `1px solid var(--rowBorderColor)`,
  },
  // Set the toolbar button color to white
  '& .MuiIconButton-root': {
    color: theme.palette.common.white,
  },
  '& .MuiOutlinedInput-root *': {
    color: theme.palette.common.white,
  },
  '& .MuiTablePagination-actions *': {
    color: theme.palette.primary.main,
  },
  '& .table-header': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  }
}));

const stringFilterOperators = getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals' || operator.value == "isEmpty" || operator.value == "isNotEmpty");

export default StyledDataGrid;
export { stringFilterOperators };
